import { Navigate, Route, Routes } from "react-router-dom";
import BillingComponent from "./billing.component";
import SubscriptionComponent from "./subscription/subscription.component";
import Cards from "./cards/cards.component";

const BillingRoutes = () => (
  <Routes>
    <Route path="/" element={<BillingComponent />}>
      <Route index element={<Navigate to="subscription" />} />
      <Route path="subscription" element={<SubscriptionComponent />} />
      <Route path="cards" element={<Cards />} />
    </Route>
  </Routes>
);

export default BillingRoutes;
